module.exports = "<footer>\n  <app-subscribe></app-subscribe>\n  <app-footer-links></app-footer-links>\n  <app-social-icons></app-social-icons>\n  <hr>\n  <p id=\"copyright\">© 2017 Massah, Inc. All Rights Reserved</p>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/footer.component.html
// module id = 414
// module chunks = 1